import { SERVICES } from "../data/content";
import { useReveal } from "../hooks/useReveal";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  const ref = useReveal();

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 lg:py-40 bg-[#F3F0EA]"
    >
      <div ref={ref} className="reveal max-w-[90rem] mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16 lg:mb-24">
          <div className="max-w-2xl">
            <p className="overline mb-6 flex items-center gap-3">
              Services
            </p>
            <h2
              data-testid="services-headline"
              className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-stone-900"
            >
              Twelve disciplines,
              <em className="italic text-[#4A6076]"> one studio</em>.
            </h2>
          </div>
          <p className="max-w-md text-stone-600 leading-relaxed">
            Every service is delivered end-to-end — from creative direction and
            material sourcing to installation and after-care. No sub-contractors,
            no compromises.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-px bg-stone-200/70 border border-stone-200/70 rounded-sm overflow-hidden">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className="group relative bg-white p-8 lg:p-10 min-h-[240px] flex flex-col justify-between transition-all duration-500 hover:bg-[#4A6076] cursor-pointer"
              >
                <div className="flex items-start justify-between">
                  <span className="w-11 h-11 rounded-full border border-stone-300 flex items-center justify-center text-stone-700 group-hover:text-white group-hover:border-white/50 transition-colors">
                    <Icon size={18} strokeWidth={1.4} />
                  </span>
                  <ArrowUpRight
                    size={20}
                    strokeWidth={1.2}
                    className="text-stone-400 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 group-hover:text-white transition-all duration-500"
                  />
                </div>
                <div>
                  <h3 className="font-serif-display text-2xl leading-tight text-stone-900 group-hover:text-white transition-colors">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[14px] leading-relaxed text-stone-600 group-hover:text-white/80 transition-colors">
                    {s.blurb}
                  </p>
                </div>
                <span className="absolute top-6 right-8 text-[11px] tracking-[0.25em] text-stone-400 group-hover:text-white/70 transition-colors font-body">
                  0{i < 9 ? `${i + 1}` : i + 1}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
